import React, { useMemo } from "react";
import { useIntl } from "react-intl";

import { translateMessage } from "src/app/methods/translateMessage";
import { useSelector } from "react-redux";

import CustomCheckbox from "src/app/components/CustomCheckbox/CustomCheckbox";
import SimpleExpander from "src/app/components/SimpleExpander/SimpleExpander";
import { uuidv7 as uuid } from "uuidv7";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { useParams } from "react-router";

export function SingleRelatedTaskFilter({ col, sendFilter, filters }) {
  const intl = useIntl();

  const { projectId } = useParams();

  const projectTasksAutocomplete = useSelector(
    (state) => state.taskReducer.projectTasksAutocomplete,
  );

  const tasksAutocomplete = (projectTasksAutocomplete[projectId] ?? []).filter(
    (item) => item.taskType === col.type,
  );

  const feed = useMemo(() => {
    const options = tasksAutocomplete;

    return (
      options?.sort((a, b) => {
        const containsA = filters[col.uuid]?.value?.includes(a.taskId);
        const containsB = filters[col.uuid]?.value?.includes(b.taskId);
        if (containsA && containsB) return a.title.localeCompare(b.title);
        if (containsA) return -1;
        if (containsB) {
          return 1;
        }
        return a.title.localeCompare(b.title);
      }) || []
    );
  }, [filters, tasksAutocomplete]);

  const feed1 = feed.slice(0, 5);
  const feed2 = feed.slice(5, feed.length);

  const onChange = (e, option) => {
    if (e.target.checked) {
      sendFilter(col.uuid, [
        ...(filters[col.uuid]?.value || []),
        option.taskId,
      ]);
    } else {
      sendFilter(col.uuid, [
        ...filters[col.uuid]?.value.filter((f) => f !== option.taskId),
      ]);
    }
  };

  const notSetUuid = uuid();

  return (
    <div className="single-select-filter-options">
      <CustomCheckbox
        id={notSetUuid}
        name={notSetUuid}
        label={<IDHFormattedMessage id="ws_blanks" defaultMessage="Blanks" />}
        onChange={(e) =>
          onChange(e, {
            title: "Blanks",
            taskId: null,
          })
        }
        checked={!!filters[col.uuid]?.value.includes(null)}
        data-qa="Blanks"
      />
      {feed1.map((option) => (
        <CustomCheckbox
          key={option.taskId}
          id={option.taskId}
          name={option.title}
          label={option.title}
          onChange={(e) => onChange(e, option)}
          checked={!!filters[col.uuid]?.value.includes(option.taskId)}
          data-qa={option.title}
        />
      ))}
      {feed2.length > 0 && (
        <SimpleExpander
          contentClassName="single-select-filter-options__expander__content"
          expandText={`${translateMessage({
            intl,
            id: "ws_more",
            defaultMessage: "More",
          })} (${feed2.length})`}
        >
          {feed2.map((option) => (
            <CustomCheckbox
              key={option.taskId}
              id={option.taskId}
              name={option.title}
              label={option.title}
              onChange={(e) => onChange(e, option)}
              checked={!!filters[col.uuid]?.value.includes(option.taskId)}
              data-qa={option.title}
            />
          ))}
        </SimpleExpander>
      )}
    </div>
  );
}
